module.exports = __webpack_public_path__ + "img/img_zhuanpan02@2x.7226f0fa.png";